module.exports = __webpack_public_path__ + "img/ear.61b40f86.svg";